module.exports = __webpack_public_path__ + "static/hell_hound-1de3c45a7271fdaf4bdc418fd37e9fc5.jpg";